
    
    import { lazy } from "react";
    import loadable, { lazy as loadableLazy } from "@modern-js/runtime/loadable"
  
    
    
    import { createShouldRevalidate, handleRouteModule,  handleRouteModuleError} from '@modern-js/runtime/router';
  
    import RootLayout from '@_modern_js_src/routes/layout'
    
    
    
    
    
    if(typeof document !== 'undefined'){
      window._routeModules = {}
    }
  
    
    export const routes = [
  {
  "path": "/",
  "children": [
    {
      "_component": "@_modern_js_src/routes/page",
      "index": true,
      "id": "page",
      "type": "nested",
      "lazyImport": () => import(/* webpackChunkName: "page" */  '@_modern_js_src/routes/page').then(routeModule => handleRouteModule(routeModule, "page")).catch(handleRouteModuleError) ,
      "component": lazy(() => import(/* webpackChunkName: "page" */  '@_modern_js_src/routes/page').then(routeModule => handleRouteModule(routeModule, "page")).catch(handleRouteModuleError) )
    },
    {
      "_component": "@_modern_js_src/routes/$",
      "path": "*",
      "id": "$",
      "type": "nested",
      "lazyImport": () => import(/* webpackChunkName: "$" */  '@_modern_js_src/routes/$').then(routeModule => handleRouteModule(routeModule, "$")).catch(handleRouteModuleError) ,
      "component": lazy(() => import(/* webpackChunkName: "$" */  '@_modern_js_src/routes/$').then(routeModule => handleRouteModule(routeModule, "$")).catch(handleRouteModuleError) )
    },
    {
      "children": [
        {
          "path": "org",
          "children": [
            {
              "path": ":slug",
              "children": [
                {
                  "children": [
                    {
                      "_component": "@_modern_js_src/routes/__public/org/[slug]/learning/__user/access-denied/course/[course_id]/page",
                      "id": "__public/org/(slug)/learning/__user/access-denied/course/(course_id)/page",
                      "type": "nested",
                      "path": "access-denied/course/:course_id",
                      "lazyImport": () => import(/* webpackChunkName: "__public/org/(slug)/learning/__user/access-denied/course/(course_id)/page" */  '@_modern_js_src/routes/__public/org/[slug]/learning/__user/access-denied/course/[course_id]/page').then(routeModule => handleRouteModule(routeModule, "__public/org/(slug)/learning/__user/access-denied/course/(course_id)/page")).catch(handleRouteModuleError) ,
                      "component": lazy(() => import(/* webpackChunkName: "__public/org/(slug)/learning/__user/access-denied/course/(course_id)/page" */  '@_modern_js_src/routes/__public/org/[slug]/learning/__user/access-denied/course/[course_id]/page').then(routeModule => handleRouteModule(routeModule, "__public/org/(slug)/learning/__user/access-denied/course/(course_id)/page")).catch(handleRouteModuleError) )
                    }
                  ],
                  "isRoot": false,
                  "_component": "@_modern_js_src/routes/__public/org/[slug]/learning/__user/layout",
                  "id": "__public/org/(slug)/learning/__user/layout",
                  "type": "nested",
                  "path": "learning",
                  "lazyImport": () => import(/* webpackChunkName: "__public/org/(slug)/learning/__user/layout" */  '@_modern_js_src/routes/__public/org/[slug]/learning/__user/layout').then(routeModule => handleRouteModule(routeModule, "__public/org/(slug)/learning/__user/layout")).catch(handleRouteModuleError) ,
                  "component": lazy(() => import(/* webpackChunkName: "__public/org/(slug)/learning/__user/layout" */  '@_modern_js_src/routes/__public/org/[slug]/learning/__user/layout').then(routeModule => handleRouteModule(routeModule, "__public/org/(slug)/learning/__user/layout")).catch(handleRouteModuleError) )
                }
              ],
              "isRoot": false,
              "_component": "@_modern_js_src/routes/__public/org/[slug]/layout",
              "id": "__public/org/(slug)/layout",
              "type": "nested",
              "lazyImport": () => import(/* webpackChunkName: "__public/org/(slug)/layout" */  '@_modern_js_src/routes/__public/org/[slug]/layout').then(routeModule => handleRouteModule(routeModule, "__public/org/(slug)/layout")).catch(handleRouteModuleError) ,
              "component": lazy(() => import(/* webpackChunkName: "__public/org/(slug)/layout" */  '@_modern_js_src/routes/__public/org/[slug]/layout').then(routeModule => handleRouteModule(routeModule, "__public/org/(slug)/layout")).catch(handleRouteModuleError) )
            }
          ],
          "isRoot": false,
          "_component": "@_modern_js_src/routes/__public/org/layout",
          "id": "__public/org/layout",
          "type": "nested",
          "lazyImport": () => import(/* webpackChunkName: "__public/org/layout" */  '@_modern_js_src/routes/__public/org/layout').then(routeModule => handleRouteModule(routeModule, "__public/org/layout")).catch(handleRouteModuleError) ,
          "component": lazy(() => import(/* webpackChunkName: "__public/org/layout" */  '@_modern_js_src/routes/__public/org/layout').then(routeModule => handleRouteModule(routeModule, "__public/org/layout")).catch(handleRouteModuleError) )
        }
      ],
      "isRoot": false,
      "_component": "@_modern_js_src/routes/__public/layout",
      "id": "__public/layout",
      "type": "nested",
      "lazyImport": () => import(/* webpackChunkName: "__public/layout" */  '@_modern_js_src/routes/__public/layout').then(routeModule => handleRouteModule(routeModule, "__public/layout")).catch(handleRouteModuleError) ,
      "component": lazy(() => import(/* webpackChunkName: "__public/layout" */  '@_modern_js_src/routes/__public/layout').then(routeModule => handleRouteModule(routeModule, "__public/layout")).catch(handleRouteModuleError) )
    },
    {
      "_component": "@_modern_js_src/routes/diplomas/[id]/page",
      "id": "diplomas/(id)/page",
      "type": "nested",
      "path": "diplomas/:id",
      "lazyImport": () => import(/* webpackChunkName: "diplomas/(id)/page" */  '@_modern_js_src/routes/diplomas/[id]/page').then(routeModule => handleRouteModule(routeModule, "diplomas/(id)/page")).catch(handleRouteModuleError) ,
      "component": lazy(() => import(/* webpackChunkName: "diplomas/(id)/page" */  '@_modern_js_src/routes/diplomas/[id]/page').then(routeModule => handleRouteModule(routeModule, "diplomas/(id)/page")).catch(handleRouteModuleError) )
    }
  ],
  "isRoot": true,
  "_component": "@_modern_js_src/routes/layout",
  "id": "layout",
  "type": "nested",
  "lazyImport": () => import('@_modern_js_src/routes/layout').then(routeModule => handleRouteModule(routeModule, "layout")).catch(handleRouteModuleError) ,
  "component": RootLayout
},
];
  